import type { Ruleset } from './types.js';

const ISO_EPOCH = new Date(0).toISOString();

export const STANDARD_RULESET_ID = 'standard';

export const STANDARD_RULESET: Ruleset = {
  id: STANDARD_RULESET_ID,
  name: 'Standard Texas 42',
  version: 1,
  enabledLayers: ['base', 'nello', 'plunge', 'splash', 'sevens', 'consensus'],
  allPassBehavior: 'redeal',
  openingBidCapMarks: null,
  allowFollowMe: true,
  allowDoublesTrump: true,
  notes: 'Factory default: partnership 42 to seven marks with standard specials.',
  createdAt: ISO_EPOCH,
  updatedAt: ISO_EPOCH,
};

export function isStandardRuleset(ruleset: Ruleset): boolean {
  return ruleset.id === STANDARD_RULESET_ID;
}

export function createStandardRuleset(now = new Date().toISOString()): Ruleset {
  return {
    ...STANDARD_RULESET,
    createdAt: now,
    updatedAt: now,
  };
}

export const TOURNAMENT_RULESET_ID = 'tournament';

export const TOURNAMENT_RULESET: Ruleset = {
  id: TOURNAMENT_RULESET_ID,
  name: 'Tournament Texas 42',
  version: 1,
  enabledLayers: ['base', 'tournament', 'consensus'],
  allPassBehavior: 'redeal',
  openingBidCapMarks: null,
  allowFollowMe: true,
  allowDoublesTrump: true,
  notes: 'Tournament restrictions: no special contracts, standard seven-mark match.',
  createdAt: ISO_EPOCH,
  updatedAt: ISO_EPOCH,
};

export const BUILTIN_RULESETS: Ruleset[] = [STANDARD_RULESET, TOURNAMENT_RULESET];

/**
 * Built-in rulesets are product truth, not user data.
 *
 * Older app versions persisted built-ins alongside custom rulesets. Ignore
 * those shadow copies so a stale IndexedDB record cannot change what
 * "Standard" or "Tournament" means in a newly-created match.
 */
export function resolveAvailableRulesets(stored: Ruleset[]): Ruleset[] {
  const builtinIds = new Set(BUILTIN_RULESETS.map(({ id }) => id));
  const custom = stored.filter(({ id }) => !builtinIds.has(id));
  return [...BUILTIN_RULESETS, ...custom];
}

export function isTournamentRuleset(ruleset: Ruleset): boolean {
  return ruleset.id === TOURNAMENT_RULESET_ID;
}

export function createTournamentRuleset(now = new Date().toISOString()): Ruleset {
  return {
    ...TOURNAMENT_RULESET,
    createdAt: now,
    updatedAt: now,
  };
}
